export const MAIN_API = '/api/dashboard/customer/main-dashboard'

export const MAIN_REVENUE_API = '/api/payment-service-module/secure/label/main-dashboard/revenue'
